import { Cart, RecoveredCart } from '@pegasus/cart';

export const SET_CART = 'cart/SET_CART';

export const SET_RECOVERED_CART = 'cart/SET_RECOVERED_CART';

export const RESET_CART = 'cart/RESET_CART';

export const setCart = (cart: Cart) => ({
    type: SET_CART as typeof SET_CART,
    payload: {
        cart,
    },
});

export const setRecoveredCart = (recoveredCart: RecoveredCart) => ({
    type: SET_RECOVERED_CART as typeof SET_RECOVERED_CART,
    payload: {
        recoveredCart,
    },
});

export const resetCart = () => ({
    type: RESET_CART as typeof RESET_CART,
});

export type Actions =
    | ReturnType<typeof resetCart>
    | ReturnType<typeof setCart>
    | ReturnType<typeof setRecoveredCart>;
